import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';

const path = "/criancas";
const subPath = "/movimentacoes"

class MovimentacaoService {
  getMovimentacoes(id) {
    return axios.get(API + path + `/${id}` + subPath + "/buscar")
  }
  postMovimentacoes(id, body) {
    return axios.post(API + path + `/${id}` + subPath, body)
  }

  postMovimentacoesFamilia(id, body) {
    return axios.post(API + path + `/${id}` + subPath + `/familia-acolhedora`, body)
  }

  putMovimentacoes(idCrianca, idMovimentacao, body) {
    return axios.put(API + path + `/${idCrianca}` + subPath + `/${idMovimentacao}`, body)
  }

  putMovimentacoesFamilia(idCrianca, idMovimentacao, body) {
    return axios.put(API + path + `/${idCrianca}` + subPath + `/${idMovimentacao}/familia-acolhedora`, body)
  }

  postMovimentacoesIntercaladasFamilia(id, body) {
    return axios.post(API + path + `/${id}` + subPath + `/intercalado-familia`, body)
  }

  postMovimentacoesIntercaladas(id, body) {
    return axios.post(API + path + `/${id}` + subPath + "/intercalado", body)
  }

  postAnexoMovimentacao(idMovimento, idCrianca, upload) {
    var formData = new FormData();
    formData.append('upload', upload);
    formData.append('idCrianca', idCrianca);

    return axios.post(API + `/anexos/anexo-movimento/${idMovimento}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  postAnexoMovimentacaoDesligamento(idMovimento, idCrianca, upload) {
    var formData = new FormData();
    formData.append('upload', upload);
    formData.append('idCrianca', idCrianca);

    return axios.post(API + `/anexos/anexo-desligamento/${idMovimento}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  postAnexoMovimentacaoPendente(idMovimento, idCrianca, upload) {
    var formData = new FormData();
    formData.append('upload', upload);
    formData.append('idCrianca', idCrianca);

    return axios.post(API + `/anexos/anexo-decisao/${idMovimento}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  postAnexoMovimentacaoAcolhimento(idMovimento, idCrianca, upload) {
    var formData = new FormData();
    formData.append('upload', upload);
    formData.append('idCrianca', idCrianca);

    return axios.post(API + `/anexos/anexo-acolhimento/${idMovimento}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  deleteMovimentacao(idCrianca, idMovimento) {
    return axios.delete(API + path + `/${idCrianca}` + subPath + `/${idMovimento}`)
  }
}

const instanceMovimentacao = new MovimentacaoService();
export default instanceMovimentacao;
